import src from "IMAGE";
export default { src, width: 242, height: 72, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARklEQVR42h3LsQkAMQgF0EwaAilSpLAQBAsbd3AAB3BE+celfryRmV1VOOeAiDDnhIjg3ou9d4+IaHfHWuuBmYGZoap/6g8CniZy23pSAgAAAABJRU5ErkJggg=="};
